CheckoutV2.PaymentV2.CreditCard.Stored = function(checkout, $container) {
    var method = this;

    this._currentPayments = [];
    
    this._init = function() {
        // Events
        checkout.cart.totals.registerTotalChangedListener(method._onTotalsChanged);

        // There was an active method from split payments, load up the cards
        if(checkout.payment.activeMethods.length) {
            checkout.payment.activeMethods.forEach(function(card) {
                method._addCurrentPayment(card);
            });
        } else {
            // Initial setup is the first stored card
            var storedPayment = method._getStoredCards()[0];
            method._addCurrentPayment(storedPayment);
        }
        method._setPaymentActiveMethods();

        // Defaults to valid on a single stored payment
        checkout.payment.onMethodValid();

        method._render();
        method._listen();
        method._listenChangeCCModal();
    };

    this._listen = function () {
        //Listener for the split payment button to launch the split payment modal
        $container.find('.js-split-payment').on('click', function(e) {
            e.preventDefault();

            var filtered = method._getAvailableCards();
            checkout.payment.splitPaymentModal.setCardSelectedCallback(method._onSplitPaymentAdded);
            if(filtered.length > 0) {
                checkout.payment.splitPaymentModal.renderStoredCards(filtered);
            } else {
                checkout.payment.splitPaymentModal.renderNewCard();
            }
        });
    };

    this._render = function() {
        $container.find('.payment-method-creditcard-container').html('');

        method._currentPayments.forEach(function(payment) {
            var $content = $($.parseHTML(Jemplate.process('includes/partials/payment/storedCreditCard.html', {
                id: payment.id,
                card_last_four: payment.last_four,
                card_expire_month: payment.expire_month,
                card_expire_year: payment.expire_year,
                card_type: payment.type,
                first_name: payment.first_name,
                last_name: payment.last_name,
                address: payment.address,
                city: payment.city,
                state: payment.state,
                zip: payment.zip,
                CDNstatic: CDNpath
            })));
            $container.find('.payment-method-creditcard-container').append($content);
        });

        // Default settings for a single card is no balance container
        $container.find('.payment-balance-container').hide();

        // Multiple payments mean split payments
        if(method._currentPayments.length > 1) {
            var $paymentMethod = $container.find('.payment-method');

            // Toggle show/ hides accordingly
            $paymentMethod.find('.payment-method-amount').show();
            $paymentMethod.find('.js-change-credit-card').hide();

            // Set inputs to the payment amount from the corresponding payment
            method._updateSplitPaymentInputs();

            // Show validation messages for payments with zero payment amount
            method._showSplitPaymentCardMessages();

            // set the remaining amount
            var remaining = method._getRemainingAmount();
            $container.find('#cart-remaining').html(remaining.toMoney());

            // Show the balances container
            $container.find('.payment-balance-container').show();

            // Since we start by adding a new card at zero, the method is invalid
            checkout.payment.onMethodInvalid();
            $container.find('.payment-balance-container').addClass('text-danger');
            $container.find('.payment-balance-container').removeClass('text-success');

            method._listenSplitPayments();
        }

        $container.find('.card-address[data-toggle="popover"]').popover();
        $container.find('.collapse').addClass('show');
        checkout.payment.loading( false );
    };

    this._listenSplitPayments = function() {
        var $paymentMethod = $container.find('.payment-method');

        // If we only have two cards, tag the second as an auto adjust field for the first
        if(method._currentPayments.length === 2) {
            $($paymentMethod[1]).attr('data-autoadjust', true);
        }

        // Listener for payment method remove buttons
        $paymentMethod.find('.payment-method-remove').on('click', function(e) {
            var $parent = $(this).parents('.payment-method');
            var id = $parent.attr('data-id');

            // remove the method with the matching id
            method.removeStoredCard(id);
        });

        // Listener for card amount blur. When this happens we need to no longer auto update
        // the first card. Behavior should be as follows:
        // 1. Only the second card in a split payment can update the first
        // 2. That second card only updates if there are exactly two cards in the split
        // 3. Once any input has changed, disable the auto balance on the second card.
        $paymentMethod.find('.js-card-amount').on('blur', function(){
            $paymentMethod.each(function(){
                if($(this).attr('data-autoadjust')) {
                    $(this).attr('data-autoadjust', false);
                }
            });
            method._updateSplitPaymentInputs();
        });

        // Listener for the card amount input changing
        $paymentMethod.find('.js-card-amount').on('input', function(){
            var $parent = $(this).parents('.payment-method');
            var id = $parent.attr('data-id');

            // Deal with empty strings in inputs
            var value = 0;
            if($(this).val() !== ''){
                value = __fixDecimals($(this).val());
            }

            // If this is the autoadust field, subtract the value from the first amount
            if($parent.attr('data-autoadjust') === 'true'){
                var cartRemaining = __fixDecimals(checkout.cart.totals.values.remaining);
                var diff = __fixDecimals(cartRemaining - value);
                if(diff <= 0) {
                    method._currentPayments[0].payment_amount = 0;
                } else {
                    method._currentPayments[0].payment_amount = diff;
                }
            }

            // Update the value of this item to the input value sent
            method._currentPayments.forEach(function(payment) {
                if(payment.id === id) {
                    payment.payment_amount = value;
                }
            });

            method._updateSplitPaymentInputs(id);
            method._showSplitPaymentCardMessages();
            method._validateSplitPayments();
        });
    };

    this._updateSplitPaymentInputs = function(updatedId) {
        var $paymentMethod = $container.find('.payment-method');

        // Set inputs to the payment amount from the corresponding payment
        // zeroes get emptied to show the placeholder
        $paymentMethod.find('.js-card-amount').each(function(idx) {
            var amount = method._currentPayments[idx].payment_amount;
            if(method._currentPayments[idx].id !== updatedId){
                if(amount > 0) {
                    $(this).val(amount.toMoney());
                } else {
                    $(this).val('');
                }
            }
        });
    };

    this._showSplitPaymentCardMessages = function() {
        var $paymentMethod = $container.find('.payment-method');

        $paymentMethod.find('.js-field-invalid').each(function(idx) {
            if(method._currentPayments[idx].payment_amount === 0) {
                $(this).removeClass('hidden');
            } else {
                $(this).addClass('hidden');
            }
        });
    };

    this._validateSplitPayments = function() {
        var remaining = method._getRemainingAmount();

        if(remaining < 0){
            $container.find('#cart-remaining').html((remaining * -1).toMoney());
        } else {
            $container.find('#cart-remaining').html(remaining.toMoney());
        }

        if(remaining === 0) {
            // We can cover the total but still have a card with zero in the payment amount.
            // This is an invalid state
            var zeroPayments = method._currentPayments.filter(function(payment) {
                return payment.payment_amount === 0;
            });
            if(zeroPayments.length) {
                $container.find('.payment-balance-container').addClass('text-danger');
                $container.find('.payment-balance-container').removeClass('text-success');
                checkout.payment.onMethodInvalid();
            } else {
                $container.find('.payment-balance-container').removeClass('text-danger');
                $container.find('.payment-balance-container').addClass('text-success');
                checkout.payment.onMethodValid();
                method._setPaymentActiveMethods();
            }
            $container.find('.js-payment-balance-verb').html('Add');
        } else if(remaining < 0) {
            // Deal with showing negative values in remaining, needs to say 'Subtract'
            //js-payment-balance-verb
            $container.find('.js-payment-balance-verb').html('Subtract');
            $container.find('.payment-balance-container').addClass('text-danger');
            $container.find('.payment-balance-container').removeClass('text-success');
            checkout.payment.onMethodInvalid();
        } else {
            // Flip back to the word 'Add' for remaining
            $container.find('.js-payment-balance-verb').html('Add');
            $container.find('.payment-balance-container').addClass('text-danger');
            $container.find('.payment-balance-container').removeClass('text-success');
            checkout.payment.onMethodInvalid();
        }
    };

    this._onTotalsChanged = function(oldTotals) {
        // Only deal with totals updates if we have split payments
        if(method._currentPayments.length > 1 && checkout.payment.activeMethods.length > 1) {
            // Added the checkout.payment.activeMethods.length > 1 check
            // Handles the case when you have split payments, then cover with available balance and then go back to stored payment
            // method._currentPayments is seeing 2 when activeMethods has 1 (correct)
            var oldCartRemaining = __fixDecimals(oldTotals.remaining);
            var currentCartRemaining = __fixDecimals(checkout.cart.totals.values.remaining);

            // Remaining value has changed which means the split payments amounts need to reset
            if(oldCartRemaining !== currentCartRemaining) {
                // zero out the existing payments, set the first one to the remaining value
                method._currentPayments.forEach(function(payment) {
                    payment.payment_amount = 0;
                });
                method._currentPayments[0].payment_amount = currentCartRemaining;

                // re init the second field with the auto adjust
                var $paymentMethod = $container.find('.payment-method');
                if(method._currentPayments.length === 2) {
                    $($paymentMethod[1]).attr('data-autoadjust', true);
                }

                // Update the input values
                method._updateSplitPaymentInputs();
                method._showSplitPaymentCardMessages();

                // Trigger the form as invalid
                checkout.payment.onMethodInvalid();
                $container.find('.payment-balance-container').addClass('text-danger');
                $container.find('.payment-balance-container').removeClass('text-success');
            }
        }
    };

    this._getRemainingAmount = function() {
        var remaining = __fixDecimals(checkout.cart.totals.values.remaining);
        method._currentPayments.forEach(function(payment) {
            remaining = remaining - payment.payment_amount;
        });
        return __fixDecimals(remaining);
    };

    // Fires when a card is changed through the change card modal
    this._onCardChanged = function(card) {
        // In this case we will have only a single payment, so clear out the current payments
        method._clearStoredCards();
        method._addCurrentPayment(card);
        method._setPaymentActiveMethods();
        method._render();
        method._listenChangeCCModal();
    };

    // TODO: finish the split payment stuff
    this._onSplitPaymentAdded = function(card) {
        // zero out the new card payment amount
        card.payment_amount = 0.00;
        method._currentPayments.push(card);
        method._setPaymentActiveMethods();
        method._render();
    };

    // The change CC modal button is dynamically added, so we need to bind this after rendering on init and on
    // card changes.
    this._listenChangeCCModal = function() {
        // Listener to launch the change CC modal
        $container.find('.js-change-credit-card').on('click', function(e){
            e.preventDefault();
            checkout.payment.changeCardModal.setCardChangedCallback(method._onCardChanged);
            checkout.payment.changeCardModal.setCurrentCard(method._currentPayments[0]);
            checkout.payment.changeCardModal.render();
            checkout.payment.changeCardModal.show();
        });
    };

    // Gets a filtered list of cards for split payment that does not include the currently selected payment cards
    this._getAvailableCards = function() {
        return method._getStoredCards().filter(function(item){
            var found = false;
            method._currentPayments.forEach(function(usedItem){
                if(usedItem.id === item.id){
                    found = true;
                }
            });
            if (!item.method.match(/storedcredit/)) 
               found = true;
            return !found;
        });
    };

    this._addCurrentPayment = function(card) {
        method._currentPayments.push(card);
    };

    this.removeStoredCard = function(id) {
        method._currentPayments = method._currentPayments.filter(function(existingCard) {
            return existingCard.id !== id;
        });

        // If we had a new card id sent to removal and the user has no stored payments,
        // remove the added card. Logged in users with previous stored payments need "add card modal"
        // to keep the cards in the addedCards array in payment.
        // Guest users and fresh authed users obviously don't have stored payments,
        // so we need to nuke their addedCards whenever they remove a split payment.
        if(id.indexOf('newcard-') !== -1 && !checkout.session.get('storedPayments').length) {
            checkout.payment.removeAddedCard(id);
        }

        // If there is one method left and the card is a "new card" and not a stored payment,
        // AND the user doesn't have any stored payments, reinit the card method to have CreditCard.New pick it up.
        if(method._currentPayments.length === 1 &&
            method._currentPayments[0].id.indexOf('newcard-') !== -1 &&
            !checkout.session.get('storedPayments').length) {
            $container.find('.payment-balance-container').hide();
            method._setPaymentActiveMethods();
            checkout.payment.setMethodByName('creditcard');
            checkout.payment.onMethodInvalid();
            return;
        }

        // if there is only one method left, treat it like a normal stored payment
        var cartRemaining = __fixDecimals(checkout.cart.totals.values.remaining);
        if(method._currentPayments.length === 1) {
            method._currentPayments[0].payment_amount = cartRemaining;
            method._setPaymentActiveMethods();
            checkout.payment.onMethodValid();
        }
        // re render the card list
        method._render();
        // re bind the change card listener
        method._listenChangeCCModal();
        // re run validation
        method._validateSplitPayments();
    };

    // Clears the existing payments
    this._clearStoredCards = function() {
        method._currentPayments = [];
    };

    // Sets the payment modules active methods
    this._setPaymentActiveMethods = function(){
        checkout.payment.setActivePaymentMethods(method._currentPayments);
    };

    this._getStoredCards = function() {
        var cards = [];

        // Grab stored payments from session
        checkout.session.get('storedPayments').forEach(function(card) {
            // skip things that are not credit cards
            if ( card.method.indexOf( "storedcreditcard" ) != 0 ) return;

            var payment = checkout.payment.models.paymentMethodFromStoredCard(card, checkout.cart.totals.values.total);
            cards.push(payment);
        });

        // Also add any cards added through the add card modal
        checkout.payment.getAddedCards().forEach(function(card) {
            cards.push(card);
        });

        return cards;
    };

    this.destroy = function() {
        // Unbind module event listeners
        checkout.cart.totals.removeTotalChangedListener(method._onTotalsChanged);

        // Unbind dom event listeners
        $container.find('.js-split-payment').off('click');
    };

    this._init();
};
